import React from 'react';


const PageNotFound = () => {


    return (
        <div style={{textAlign: 'center'}}>
            <h1>Sorry!!</h1>
            <h3>We couldn't find what you were looking for.</h3>
        </div>
    )
}

export default PageNotFound;